import { MouseEventHandler, ReactNode } from 'react';

import { css, cx } from '@flipster/styled-system/css';
import { Space } from '@flipster/ui/Space';

interface Props {
  items: { label: ReactNode; value: string }[];
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const PriceRateButtons = ({ items, onClick, className }: Props) => {
  return (
    <Space space='medium'>
      {items.map((item) => {
        return (
          <button
            type='button'
            value={item.value}
            key={item.value}
            onClick={onClick}
            className={cx(css(buttonStyle), className)}
          >
            {item.label}
          </button>
        );
      })}
    </Space>
  );
};

export default PriceRateButtons;

const buttonStyle = css.raw({
  position: 'relative',
  flex: 1,
  h: 32,
  textStyle: 'Text/S/Strong',
  color: 'content.default.level-2',
  bgColor: 'background.default.level-2',
  rounded: 4,
  '&:active': {
    color: 'content.default.level-4',
  },
  '&:not(:disabled)': {
    '&:focus': {
      '&::before': {
        position: 'absolute',
        inset: '-2px',
        content: "''",
        border: '1px solid',
        borderColor: 'content.accent.info',
        rounded: 4,
      },
    },
  },
});
